import React from 'react'
import { Modal } from 'antd'
import gql from 'graphql-tag'
import Placeholder from '@/components/common/placeholder'
import { useFormContext } from '@/state/main-form/reducer'
import { useMetabaseInfoBlockDashboardEmbedUrlQuery } from './__gen/modal-dashboard'
import style from './index.module.sass'

gql`
	query metabaseInfoBlockDashboardEmbedUrl($id: ID!, $recordId: ID, $code: String) {
		metabaseInfoBlockDashboard(id: $id) {
			id
			name
			embedUrl(recordId: $recordId, publicFormCode: $code)
		}
	}
`

type Props = {
	id: string
	name: string
	setShowModal: (showModal: boolean) => void
}

export const InfoBlockModalDashbaord = (props: Props) => {
	const formContext = useFormContext()
	const { data, loading } = useMetabaseInfoBlockDashboardEmbedUrlQuery({
		context: {
			headers: {
				'X-Public-Form-Code': formContext.publicForm ? formContext.publicForm.code : '',
			},
		},
		variables: {
			id: props.id,
			...(formContext.publicForm ?
				{
					code: formContext.publicForm.code,
				}
			:	{ recordId: formContext.record.id }),
		},
	})
	const closeModal = () => {
		props.setShowModal(false)
	}

	return (
		<Modal open width="100%" centered onOk={closeModal} onCancel={closeModal} footer={null}>
			{loading ?
				<div className={style.loadingContainer}>
					<Placeholder className={style.card} />
					<Placeholder className={style.card} />
					<Placeholder className={style.card} />
					<Placeholder className={style.card} />
				</div>
			: !data?.metabaseInfoBlockDashboard?.embedUrl ?
				<div>Error loading embed URL</div>
			:	<div className={style.container}>
					<iframe src={data.metabaseInfoBlockDashboard.embedUrl} className={style.iframe} />
				</div>
			}
		</Modal>
	)
}
